"use client";
import React from "react";
import Link from "next/link";
import { useBookmarksContext } from "@/context/BookmarksProvider";
import { Star } from "lucide-react";
import { usePathname } from "next/navigation";

const HeaderBookmarkBtn = () => {
  const { bookmarks } = useBookmarksContext();
  const pathname = usePathname();

  let totalTools = bookmarks.length > 9 ? "9+" : bookmarks.length;
  const isActive = pathname === "/bookmarks";

  return (
    <Link
      href="/bookmarks"
      className="color_black relative"
      style={{ letterSpacing: 0 }}
    >
      <Star
        className="sm:size-10 size-9"
        strokeWidth={1.75}
        fill={isActive ? "currentColor" : "none"}
      />
      <span className="absolute flex items-center justify-center size-6 text-xs font-bold text-white rounded-full -top-1 -right-2 bg_red border border-red-600 neue_machina_regular animate-pulse">
        {totalTools}
      </span>
    </Link>
  );
};

export default HeaderBookmarkBtn;
